import * as dragonBones from "pixi-dragonbones"
import BaseView from "./BaseView";

export default class DragonBonesAnimation {
    public armatureDisplay: any;
    private dbFactory: any;

    constructor(armatureName: string, skeletonData, spriteSheet, spriteSheetImage) {
        const db = dragonBones as any;
        this.dbFactory = db.PixiFactory.factory;
        this.dbFactory.parseDragonBonesData(skeletonData);
        this.dbFactory.parseTextureAtlasData(spriteSheet, spriteSheetImage);
        this.armatureDisplay = this.dbFactory.buildArmatureDisplay(armatureName);
    }

    play(animationName?: string, count?: number): Promise<boolean> {
        return new Promise((res) => {
            const db = dragonBones as any;
            this.armatureDisplay.animation.play(animationName, count);
            let animComplete;
            animComplete = ()=>{
                res();
            }
            this.armatureDisplay.once(db.EventObject.LOOP_COMPLETE, animComplete, this);
            this.armatureDisplay.once(db.EventObject.COMPLETE, animComplete, this);
        });
    }
    
    goToAndStop(animationName?: string) {
        this.armatureDisplay.animation.gotoAndPlayByProgress(animationName, 1,1);
    }

    stop(animationName?: string) {
        this.armatureDisplay.animation.stop(animationName);
    }

    stopOnComplete(hideOnComplete = true) {
        const db = dragonBones as any;
        // this.armatureDisplay.once(db.EventObject.COMPLETE, () => {
        //     this.armatureDisplay.removeAllListeners();
        //     this.stop()
        // }, this);

        this.armatureDisplay.once(db.EventObject.LOOP_COMPLETE, () => {
            this.armatureDisplay.removeAllListeners();
            this.stop();
            this.armatureDisplay.visible = !hideOnComplete;
        }, this);
    }

    public destroy(): void {
        this.armatureDisplay.animation.stop();
        this.armatureDisplay.parent.removeChild(this.armatureDisplay);
        this.armatureDisplay = null;
        this.dbFactory = null;
    }
}